enum GeofenceMode {
  Dynamic = 'dynamic-geofences',
  Radius = 'radius',
}

export default GeofenceMode;
